var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length > 0)?_c('div',{staticClass:"text-sm",attrs:{"id":"field-error-message-component"}},_vm._l((_vm.errors),function(error,i){return _c('p',{key:'error-'+i,staticClass:"text-red-500"},[_c('small',[_vm._v(_vm._s(error))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }